import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';
import {parseString} from 'xml2js';

export const MODULE_NAME = 'LIVE_REPORTING';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const LOAD_LEGAL_ENTITIES_OK = namespaced('LOAD_LEGAL_ENTITIES_OK');
const ADD_LEGAL_ENTITY_OK = namespaced('ADD_LEGAL_ENTITY_OK');
const UPDATE_LEGAL_ENTITY_OK = namespaced('UPDATE_LEGAL_ENTITY_OK');
const DELETE_LEGAL_ENTITY_OK = namespaced('DELETE_LEGAL_ENTITY_OK');

export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_LEGAL_ENTITIES_OK,
  LOAD_FAIL,
  ADD_LEGAL_ENTITY_OK,
  UPDATE_LEGAL_ENTITY_OK,
  DELETE_LEGAL_ENTITY_OK
};

export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {hulrTransmissions: action.response, loading: false, error: null});
      case LOAD_FAIL:
        return Object.assign({}, state, {loading: false, error: action.error});
      case LOAD_LEGAL_ENTITIES_OK:
        return Object.assign({}, state, {leaglEntities: action.response, loading: false, error: null});
      case ADD_LEGAL_ENTITY_OK:
        return Object.assign({}, state, {addActionResult: action.response, loading: false, error: null});
      case UPDATE_LEGAL_ENTITY_OK:
        return Object.assign({}, state, {updateActionResult: action.response, loading: false, error: null});
      case DELETE_LEGAL_ENTITY_OK:
        return Object.assign({}, state, {deleteActionResult: action.response, loading: false, error: null});
      default:
        return state;  
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction: ', action, newState );
  return newState;
};

export const API = {
  doLoadHULRTransmissions: (params) => {
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      log.debug('getHULRTransmissions(): params: ', params);
      CLIENT.getHULRTransmissions(params)
        .then((response) => {
          dispatch({type: LOAD_OK, response: response});
        })
        .catch((error) => {
          dispatch({type: LOAD_FAIL, error});
        });
    };
  },

  doGetLegalEntities: (params) => {
    return (dispatch, state) => {
      dispatch({type: LOAD});
      log.debug('doGetLegalEntities(): params: ' + params);
      CLIENT.getLegalEntities(params).then((response) => {
        dispatch({type: LOAD_LEGAL_ENTITIES_OK, response: response});
      }).catch((error) => {
        dispatch({type: LOAD_FAIL, error});
      }); 
    };
  },

  doAddLegalEntity: (params, done) => {
    done = typeof done === 'function' ? done : () => {};
    return (dispatch, state) => {
      dispatch({type: LOAD});
      log.debug('doAddLegalEntity(): params: ', params);
      CLIENT.addLegalEntity(params).then((response) => {
        dispatch({type: ADD_LEGAL_ENTITY_OK, response: response});
        done();
      }).catch((error) => {
        dispatch({type: LOAD_FAIL, error});
        done();
      }); 
    };
  },

  doUpdateLegalEntity: (taxNumber, params, done) => {
    done = typeof done === 'function' ? done : () => {};
    return (dispatch, state) => {
      dispatch({type: LOAD});
      log.debug('doUpdateLegalEntity(): taxNumber %s, params: ', taxNumber, params);
      CLIENT.updateLegalEnity(taxNumber, params).then((response) => {
        dispatch({type: UPDATE_LEGAL_ENTITY_OK, response: response});
        done();
      }).catch((error) => {
        dispatch({type: LOAD_FAIL, error});
        done();
      }); 
    };
  },

  doDeleteLegalEntity: (taxNumber, done) => {
    done = typeof done === 'function' ? done : () => {};
    return (dispatch, state) => {
      dispatch({type: LOAD});
      log.debug('doDeleteLegalEntity(): taxNumber %s, params: ', taxNumber);
      CLIENT.deleteLegalEnity(taxNumber).then((response) => {
        dispatch({type: DELETE_LEGAL_ENTITY_OK, response: response});
        done();
      }).catch((error) => {
        dispatch({type: LOAD_FAIL, error});
        done();
      }); 
    };
  }
};

export default API;